import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { GalleryManagementService } from 'src/service/gallery-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, FileUploadFor, FocusInputType, GalleryType, KeyValues10, LocalService, NumericConfig, Status, TriggeredEvent } from 'src/service/local.service';

@Component({
  selector: 'app-gallery-config',
  templateUrl: './gallery-config.component.html',
  styleUrl: './gallery-config.component.scss'
})
export class GalleryConfigComponent {
  FileUploadFor = FileUploadFor;
  @ViewChild('content_gallery_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["gallery"];
  @Input() galleryType: GalleryType = GalleryType.None;
  @Input() id: string = ''; @Input() parentId: string = ''; @Input() businessId: string = '';

  items: KeyValues10[]; idToDelete: string = ''; parentIdToDelete: string = ''; maxItemsLimit: number = 5;
  editItems: KeyValues10[] = []; numericConfig: NumericConfig = { isDecimalAllowed: false, isNegativeAllowed: false, maxDigits: 1, maxValue: this.maxItemsLimit } as NumericConfig;

  htmlId: string = ''; elementIds: any;
  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private galleryManagementService: GalleryManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txtTitle: 'txt_title_' + this.htmlId + '_',
      txtOrder: 'txt_order_' + this.htmlId + '_'
    }
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
    this.idToDelete = '';
    this.parentIdToDelete = '';
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.onReset();
    this.galleryManagementService.getGalleriesByType(this.galleryType, this.businessId, this.parentId ?? this.businessId).subscribe(result => {
      this.editItems = [];
      result.forEach(x => {
        x.isReadonly = true;
        this.editItems.push({
          isSelected: x.isSelected,
          isReadonly: x.isReadonly,
          key: x.key,
          v1: x.v1,
          v2: x.v2,
          v3: x.v3,
          v4: x.v4,
          v5: x.v5,
          v6: x.v6
        } as KeyValues10);
      });
      this.items = result;
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        //Active inactive
        this.galleryManagementService.activeInactiveStatus(key, ActiveInactiveFor.Gallery).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onLoad();
          }
        });
      } break;
      case 2: {
        //Delete
        this.idToDelete = key;
      } break;
      case 3: {
        //Edit
        this.items.forEach(x => x.isReadonly = true);
        this.items.find(x => x.key == key).isReadonly = false;
        let idx = this.items.findIndex(x => x.key == key);
        this.localService.onFocusNextInput(this.elementIds.txtTitle + (idx + 1), FocusInputType.TextBox);
      } break;
      case 4: {
        //Delete all
        this.parentIdToDelete = this.parentId;
      } break;
      case 5: {
        //View image
        let item = this.items.find(x => x.key == key);
        if (item) {
          this.localService.galleryViewUrl = [item.v6];
        }
      } break;
      case 6: {
        //Save edit
        let editItem = this.editItems.find(x => x.key == key);
        this.galleryManagementService.saveGallery(key, editItem.v1, editItem.v5).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onLoad();
          }
        });
      } break;
      case 7: {
        //Cancel edit
        this.items.find(x => x.key == key).isReadonly = true;
      } break;
      case 8: {
        //Copy link
        this.localService.copyContent(key);
      } break;
    }
  }

  onCloseMessageBox(result) {
    if (result.event == TriggeredEvent.Ok) {
      this.galleryManagementService.removeGallery(this.idToDelete, this.parentIdToDelete ?? this.parentId, this.businessId, this.galleryType).subscribe(result => {
        this.onLoad();
      });
    }
    this.idToDelete = '';
    this.parentIdToDelete = '';
  }
}
